// This file MUST stay in the tourniquet/ directory — the relative path
// is resolved by Vite at build time to discover and bundle the locale files.
const localeModules = import.meta.glob('./locales/*.json');

export const loadTourniquetLocale = (code: string) => {
  const path = `./locales/${code}.json`;
  const loader = localeModules[path];
  if (!loader) return Promise.reject(new Error(`Tourniquet locale not found: ${code}`));
  return loader().then((mod) => (mod as { default: unknown }).default);
};
